import React from 'react';
import QRCode from 'react-qr-code';
import { Modal, Box, Typography, Button, CircularProgress } from '@mui/material';
import { Timer, Refresh } from '@mui/icons-material';

const QRPaymentModal = ({
  open,
  onClose,
  qrData,
  paymentStatus,
  qrExpirationTime,
  paymentReference,
  onRefresh,
  formatRemainingTime,
  formatQRImage
}) => {
  return (
    <Modal
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          onClose();
        }
      }}
      disableEscapeKeyDown={true}
      aria-labelledby="modal-qr"
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { xs: '90%', sm: 400 },
        maxWidth: 400,
        maxHeight: '90vh',
        overflowY: 'auto',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 3,
        borderRadius: 2,
      }}>
        {qrData ? (
          <>
            <Typography variant="h6" component="h2" textAlign="center" sx={{ mb: 1, color: "#0b0062" }}>
              Escanea para pagar
            </Typography>
            <Typography variant="body2" textAlign="center" sx={{ mb: 1.5 }}>
              Utilizá tu billetera virtual o aplicación de pagos para escanear el QR y completar el pago.
            </Typography>

            <QRDisplay qrData={qrData} formatQRImage={formatQRImage} />

            <PaymentDetails qrData={qrData} />

            {paymentStatus && <PaymentStatusBadge status={paymentStatus} />}

            <Typography variant="caption" color="error" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
              <Timer fontSize="small" sx={{ mr: 0.5, fontSize: 16 }} />
              El QR expira en {formatRemainingTime(qrExpirationTime)}
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
              <Button variant="outlined" onClick={onClose} size="small" sx={{
                flex: 1,
                borderColor: "#5656ff",
                color: "#5656ff",
                '&:hover': {
                  borderColor: "#4040cc",
                  backgroundColor: "rgba(86, 86, 255, 0.04)"
                }
              }}>
                Cerrar
              </Button>
              <Button
                className="boton-submit"
                onClick={onRefresh}
                size="small"
                startIcon={<Refresh />}
                sx={{ flex: 1 }}
                disabled={!paymentReference}
              >
                Actualizar
              </Button>
            </Box>
          </>
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
            <CircularProgress size={24} />
            <Typography sx={{ ml: 2 }}>Cargando QR...</Typography>
          </Box>
        )}
      </Box>
    </Modal>
  );
};

const QRDisplay = ({ qrData, formatQRImage }) => (
  <Box sx={{ textAlign: 'center', mb: 2, display: 'flex', justifyContent: 'center' }}>
    {qrData.provider === 'clickmacro' || qrData.provider === 'mercadopago' ? (
      <QRCode value={qrData.qrData || qrData.qr_textual || ''} size={180} />
    ) : (
      <img src={formatQRImage(qrData.qrImage || qrData.qrData)} alt="QR de pago" style={{ maxWidth: '200px', height: 'auto' }} />
    )}
  </Box>
);

const PaymentDetails = ({ qrData }) => (
  <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    gap: 0.75,
    backgroundColor: '#f9f9f9',
    p: 1.25,
    borderRadius: 1,
    mb: 2
  }}>
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Typography variant="subtitle2">Importe</Typography>
      <Typography variant="subtitle2" fontWeight="bold">
        ${(qrData.amount || qrData.monto_total || 0).toFixed(2)}
      </Typography>
    </Box>
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Typography variant="subtitle2">Referencia</Typography>
      <Typography variant="body2" fontFamily="monospace">
        {qrData.reference || qrData.referencia}
      </Typography>
    </Box>
  </Box>
);

const PaymentStatusBadge = ({ status }) => (
  <Box sx={{
    p: 1.25,
    borderRadius: 1,
    mb: 2,
    backgroundColor: status === 'APROBADO' ? '#d4edda' : status === 'PENDIENTE' ? '#fff3cd' : '#f8d7da',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
  }}>
    <Box component="span" sx={{
      width: 10,
      height: 10,
      borderRadius: '50%',
      backgroundColor: status === 'APROBADO' ? '#28a745' : status === 'PENDIENTE' ? '#ffc107' : '#dc3545'
    }} />
    <Typography variant="body2" fontWeight="medium">Estado: {status}</Typography>
  </Box>
);

export default QRPaymentModal;